export default __webpack_public_path__ + "static/Avenir-Light-07-d2b2e045a6fd396019b22107b7d2cae1.woff";